import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TokenStorageService } from '../../services/token-storage.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { environment } from '../../environments/environment';
import { OtpVerifyComponent } from '../otp-verify/otp-verify.component';
import { MatDialog } from '@angular/material/dialog';
import { ChatService } from '../../services/chat.service';
import { lastValueFrom } from 'rxjs';
import { HomeConversationModel } from '../../models/home-conversation.model';

@Component({
  standalone: true,
  selector: 'app-home',
  imports: [CommonModule, FormsModule],
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  private urlParams:any;
  public pageReady: boolean = false;
  public storageConversations: HomeConversationModel[] = [];
  public organizationId:string = '';
  public conversationId:string = '';
  public joinCode:string = '';

  constructor(
    private _dialog: MatDialog,
    private route: ActivatedRoute,
    private router: Router,
    private _tokenStorage: TokenStorageService,
    private _chatService: ChatService) { }

  async ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.urlParams = params;
    });

    let conversations = this._tokenStorage.getAllStorageConversations();
    
    for (const storageItem of conversations) {
      if (storageItem.details?.accessToken) {
        try {
          this._chatService.setAccessToken(storageItem.details.accessToken);
          const conv = await lastValueFrom(this._chatService.fetchConversation());

          if (conv.detail && conv.messages) {
            const lastMessage = conv.messages.sort((a, b) => new Date(a.createdOn).getTime() - new Date(b.createdOn).getTime()).at(-1);

            const conversation: HomeConversationModel = {
              conversationId: storageItem.conversationId,
              details: storageItem.details || null,
              assignedToName: conv.detail.assignedToName,
              createdOn: conv.detail.createdOn,
              createdBy: conv.detail.createdBy,
              joinedOn: conv.detail.joinedOn,
              oganizationId: conv.detail.oganizationId,
              lastMessage: lastMessage?.messageText || '',
              lastUpdate: lastMessage?.createdOn || '',
              media: lastMessage?.media && lastMessage?.media?.length > 0 ? true : false
            };

            this.storageConversations.push(conversation);
          }
        } catch (error) {
          console.error('Error fetching conversation history:', error);
        }
      }
    }

    this.pageReady = true;
  }

  getChatUrl() {
    const baseUrl = this.router.url.split('?')[0];
    const queryString = new URLSearchParams(this.urlParams).toString();
    return `/chat${queryString ? '?' + queryString : ''}`;
  }

  openChat(){
    document.location.href = `${environment.baseUrl}/chat?conversationId=${this.conversationId}&organizationId=5224f59e-5568-4381-9ebc-8ec1c651bd3d&joinCode=${this.joinCode}`;
  }

  openOtpVerifyWindow(event: Event){
    event.preventDefault();
    const dialogRef = this._dialog.open(OtpVerifyComponent, {
      width: '500px',
      data: {}
    });

    dialogRef.afterClosed().subscribe(async result => {});
  }
}
